<template>
  <HeaderSection />
  <div class="bg-black py-36 flex flex-col items-center justify-center min-h-[29rem]">
    <h2 class="text-5xl">¡GRACIAS POR INSCRIBIRTE!</h2>
    <h2 class="text-xl mt-5">YA FORMAS PARTE DE CORDOBA TECH WEEK </h2>

  </div>

</template>

<script lang="ts">
import HeaderSection from './HeaderSection.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    HeaderSection

  },
});

</script>